import { useState } from 'react';
import { CPDService } from '../../../../services/cpd.service';
import { AlertService } from '../../../../services/alert.service';
import Icon from '../../../../components/forms/icon.component';

/**
 * Fuerza el hot-reload de la config CPD en los FS (POST /v1/cpd/reload →
 * publish Redis `cpd:config:changed`). El backend ya publica al guardar, este
 * botón es para forzarlo a mano (p. ej. tras un FS que se reconectó).
 * Requiere rol supervisor/admin en el backend.
 */
export default function CpdReloadButton({ className = '' }: { className?: string }) {
  const [busy, setBusy] = useState(false);

  const onClick = async () => {
    const ok = await AlertService.question(
      'Recargar configuración en los FS',
      'Se publicará un aviso a todos los workers CPD para que vuelvan a leer templates, operadores, rutas y overrides. No corta llamadas en curso.',
      () => Promise.resolve(true),
      'Recargar'
    );
    if (!ok) return;
    try {
      setBusy(true);
      const res = await CPDService.reload();
      if (res?.ok) {
        AlertService.toastSuccess(
          `Reload publicado. Suscriptores notificados: ${res.subscribers ?? 0}${
            !res.subscribers ? ' (¿ningún FS conectado a Redis?)' : ''
          }`
        );
      } else {
        AlertService.toastError('El backend respondió sin ok=true al reload.');
      }
    } catch (error: any) {
      AlertService.toastError(error?.error || 'No se pudo publicar el reload');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={`btn btn-light-warning d-flex align-items-center gap-2 hover-scale fs-7 fw-bold rounded-pill ${className}`}
      onClick={onClick}
      disabled={busy}
      title="POST /v1/cpd/reload"
    >
      <Icon icon="ki-arrows-circle" size="fs-3" />
      {busy ? 'Recargando…' : 'Recargar FS'}
    </button>
  );
}
